module.exports = __webpack_public_path__ + "static/media/validating.106391d8.png";